'use client';

import { motion } from 'framer-motion';
import { useIsScreen } from '@/app/hooks';

// 动画变体配置
const fadeInUpVariants = ({ hiddenY = 100 }: { hiddenY?: number }) => ({
  hidden: { opacity: 0, y: hiddenY },
  visible: (custom: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.2,
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1] as const,
    },
  }),
});

interface TitleSectionProps {
  title: string;
  description: string;
  custom?: number;
}

/**
 * 标题部分组件，处理PC和移动端的不同布局
 */
export const TitleSection = ({ title, description, custom = 0 }: TitleSectionProps) => {
  const { isMdScreen } = useIsScreen();
  return isMdScreen ? (
    <div className="mt-8 flex flex-col items-center justify-center py-10">
      <div className="px-14 text-center font-semibold text-[36px] text-white leading-none md:text-[28px]">{title}</div>
      <div className="my-4 h-[2px] w-[50px] bg-white opacity-[0.24]" />
      <div className="px-14 text-center text-[16px] text-white leading-[22px] opacity-65">{description}</div>
    </div>
  ) : (
    <motion.div
      className="mb-8 flex items-center justify-center gap-10"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.5 }}
      variants={fadeInUpVariants({ hiddenY: 15 })}
      custom={custom}
    >
      <h2 className="font-medium text-[48px] text-white md:text-[36px] lg:text-[40px]">{title}</h2>
      <div className="h-[50px] w-[2px] bg-white opacity-[0.24]" />
      <div className="w-[405px] text-[16px] text-white leading-[22px] opacity-65">{description}</div>
    </motion.div>
  );
};
